// Signed balances (accounting review P0-3), same rule as backend/utils/balanceSql.js.
// Liabilities are stored negative when money is owed, so the amount owed is
// -current_balance: a card in credit shows a negative amount owed instead of
// being hidden by Math.abs.
export function owedAmount(account) {
  const balance = Number(account?.current_balance) || 0;
  return balance === 0 ? 0 : -balance;
}

// Share of the credit limit in use (0 when in credit or no limit).
export function utilization(account) {
  const limit = Number(account?.credit_limit) || 0;
  if (limit <= 0) return 0;
  return Math.max(owedAmount(account), 0) / limit;
}

// An asset below zero (overdrawn) or a liability above zero (in credit).
export function signLooksWrong(account) {
  const balance = Number(account?.current_balance) || 0;
  return account?.is_liability ? balance > 0 : balance < 0;
}

// Text for the "Used" column / card. No limit, a closed account, or a limit so
// small the share is meaningless (over 10x the limit) shows no percentage.
export function usedLabel(account) {
  const limit = Number(account?.credit_limit) || 0;
  if (limit <= 0 || account?.is_active === false) return '—';
  const share = utilization(account);
  if (share > 10) return 'Over limit';
  return `${(share * 100).toFixed(1)}%`;
}
